import { api } from "./client";

export const SupportAPI = {
  create: (payload) => api.post("/public/support/tickets", payload, { skipAuthRedirect: true }),
  myTickets: () => api.get("/support/tickets"),
  listForAdmin: (status = "ALL") => api.get("/admin/support/tickets", { params: { status } }),
  updateForAdmin: (id, payload) => api.patch(`/admin/support/tickets/${id}`, payload),
};
